import { AllowedPanValues } from "shared/games/mixpuzzles/types";
import useMeasure from "util/useMeasure";
import Knob from "./Knob";
import Labels from "./Labels";
import {
  allowedPanValuesToValue,
  valueToAllowedPanValues,
} from "./valueConverters";
import { useLockedBody } from "usehooks-ts";

interface Props {
  value: AllowedPanValues;
  onChange: (value: AllowedPanValues) => void;
  disabled?: boolean;
  diameter?: number;
  theme?: "default" | "white";
}

export default function PanKnob({ value, onChange, theme = "default" }: Props) {
  const [{ width }, ref] = useMeasure<HTMLDivElement>();
  const diameter = width * 0.65;
  const [, setLocked] = useLockedBody(false);

  return (
    <div className="aspect-h-4 aspect-w-4 w-full font-brik" ref={ref}>
      <div
        className="absolute inset-0 left-1/2 -translate-x-1/2"
        style={{ height: diameter, width: diameter, top: diameter * 0.35 }}
        onTouchStart={() => setLocked(true)}
        onTouchEnd={() => setLocked(false)}
      >
        <Knob
          theme={theme}
          diameter={diameter}
          min={0}
          max={100}
          value={allowedPanValuesToValue(value)}
          step={25}
          onValueChange={(value) => {
            onChange(valueToAllowedPanValues(value));
          }}
        />

        <Labels diameter={diameter} />
      </div>
    </div>
  );
}
